{
  "eyebrow": "Rozliczenie i płatność",
  "title": "Prawie gotowe.",
  "sub": "Przejdź do bezpiecznej kasy, aby rozpocząć 30-dniowy okres próbny. Nie obciążymy Cię dzisiaj.",
  "summary": {
    "company": "Firma",
    "plan": "Plan",
    "cycle": "Cykl rozliczeniowy",
    "users": "Użytkownicy",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Pojazdy",
    "total": "Szacowany koszt / miesiąc",
    "vttOn": "W cenie"
  },
  "secureNote": "Bezpieczna kasa przez Stripe · 30 dni próbnych · Anuluj w dowolnym momencie",
  "continue": "Przejdź do Stripe",
  "submitting": "Otwieranie Stripe…",
  "canceled": {
    "title": "Płatność anulowana",
    "sub": "Nie pobrano żadnej opłaty. Spróbuj ponownie lub skontaktuj się z nami w razie potrzeby.",
    "retry": "Spróbuj ponownie"
  },
  "promo": {
    "toggle": "Masz kod promocyjny?",
    "placeholder": "Kod promocyjny",
    "apply": "Zastosuj",
    "chip": "{{percent}}% zniżki",
    "remove": "Usuń kod promocyjny",
    "errorGeneric": "Nie udało się sprawdzić kodu. Spróbuj ponownie."
  },
  "errors": {
    "generic": "Nie udało się rozpocząć płatności. Spróbuj ponownie."
  },
  "totalUnavailable": "Katalog cen niedostępny. Spróbuj ponownie, aby załadować aktualne ceny."
}
